export default class DatabaseConnectionsConfigurationList {
	constructor(
		public connectionName: string,
		public connectionAlias: string,
		public client: string,
	) { }

	static make(data: any): DatabaseConnectionsConfigurationList {
		return new DatabaseConnectionsConfigurationList(
			data.connection_name,
			data.connection_alias,
			data.client,
		);
	}
}
